import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { Colors } from '../../models/enums/colors.enum';

@Component({
  selector: 'app-row',
  templateUrl: './row.component.html',
  styleUrls: ['./row.component.scss']
})
export class RowComponent implements OnInit {
  @Input() background: string = Colors.background;
  @Input() align: string = 'space-around';
  @Input() padding: string = '0px';
  @Input() height: string;
  @Input() width: string;
  @Input() alignItems: string;
  @Input() wrap: string = 'nowrap';
  @Input() grow: boolean = false;

  @HostBinding('class.grow') growRow: boolean = false;

  constructor() { }

  ngOnInit() {
    this.growRow = this.grow;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/row/row.component.ts